import { render, staticRenderFns } from "./GewerbePage.vue?vue&type=template&id=10b80443&"
import script from "./GewerbePage.vue?vue&type=script&lang=js&"
export * from "./GewerbePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports